import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { injectIntl, FormattedNumber } from 'react-intl';

import { round, getSubtotal, getDeposit, getDepositAmount, getTotalDue, listVatSum } from 'helpers/financial';

class SalesDocumentSummary extends React.Component {
  render() {
    const {
      intl: { messages },
      doc,
    } = this.props;

    const currency = doc.currency || doc.getCurrency();
    const subtotal = getSubtotal(doc);
    const deposit = getDeposit(doc);
    const depositAmount = getDepositAmount(doc);
    const totalDue = getTotalDue(doc);

    return (
      <div class="key-value-display text-right">
        <Row>
          <Col xs={4}>{messages.salesDoc.subtotal}</Col>
          <Col xs={8}>
            <div class="text-right">
              <FormattedNumber value={subtotal} style="currency" currency={currency} />
            </div>
          </Col>
        </Row>

        {listVatSum(doc)}

        <Row>
          <Col xs={4}>
            <strong>{messages.salesDoc.total_due}</strong>
          </Col>
          <Col xs={8}>
            <div class="text-right">
              <strong>
                <FormattedNumber value={totalDue} style="currency" currency={currency} />
              </strong>
            </div>
          </Col>
        </Row>

        {!!deposit.value && (
          <React.Fragment>
            <Row>
              <Col xs={4}>
                {messages.deposit} {deposit.type === 'percent' && <strong>{deposit.value}%</strong>}
              </Col>
              <Col xs={8}>
                <div class="text-right">
                  - <FormattedNumber value={depositAmount} style="currency" currency={currency} />
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={4}>
                <strong>{messages.balance_due}</strong>
              </Col>
              <Col xs={8}>
                <div class="text-right">
                  <FormattedNumber value={totalDue - depositAmount} style="currency" currency={currency} />
                </div>
              </Col>
            </Row>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default injectIntl(SalesDocumentSummary);
